(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shiftminimal-product-activity"] && !Shopify.designMode) return;
  try {
    
  class ShiftminimalSocialProof extends HTMLElement {
    connectedCallback() {
      if (this.dataset.lockCounts === 'true') return;
      if (!this.querySelector('[data-social-viewing-text]')) return;

      this.viewingText = this.querySelector('[data-social-viewing-text] .shiftminimal-social-proof__copy');
      this.min = Number(this.dataset.viewingMin);
      this.max = Number(this.dataset.viewingMax);
      this.template = this.dataset.viewingTemplate || '';
      this.current = this.readCount();
      const wait = 7000 + Math.floor(Math.random() * 6000);
      this.timer = setInterval(() => this.nudge(), wait);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    readCount() {
      const text = this.viewingText?.textContent || '';
      const match = text.match(/\d+/);
      return match ? Number(match[0]) : this.min;
    }

    nudge() {
      const delta = Math.random() < 0.5 ? -1 : 1;
      const next = Math.min(this.max, Math.max(this.min, this.current + delta));
      if (next === this.current) return;
      this.current = next;
      if (this.template.includes('__N__')) {
        this.viewingText.textContent = this.template.replaceAll('__N__', String(next));
      }
    }
  }

  if (!customElements.get('shiftminimal-social-proof')) {
    customElements.define('shiftminimal-social-proof', ShiftminimalSocialProof);
  }

  } catch(e) { console.error(e); }
})();
})();
